'use client';

import { useEffect } from 'react';

import { MIXPANEL_APP_FEATURES, mixpanelEvents } from '@/shared/constants/mixpanel-events';
import { useIdleIntercom } from '@/shared/hooks/use-intercom-widget';
import { emitMixpanelEvent } from '@/shared/utils/mixpanel-utils';

import { MARKETING_PAGE } from '../../utils/marketing-analytics';

type AlternativesPageEffectsProps = {
	/** Anchor name, lower-cased into the event like the compare pages do. */
	competitor: string;
};

/**
 * Client-only side effects for an alternatives guide: the compare-page view
 * event (with `page: alternatives` to tell it apart from the vs page for the
 * same competitor) and the Intercom widget. A null island so the page itself
 * stays a server component.
 */
export const AlternativesPageEffects = ({ competitor }: AlternativesPageEffectsProps) => {
	useIdleIntercom();

	useEffect(() => {
		emitMixpanelEvent(mixpanelEvents.VIEWED_COMPARE_PAGE, {
			feature: MIXPANEL_APP_FEATURES.COMPARE_PAGE,
			competitor: competitor.toLowerCase(),
			page: MARKETING_PAGE.ALTERNATIVES,
		});
	}, [competitor]);

	return null;
};
